import React from 'react';
import { MODAL_IDS } from '@src/containers/Session/constants';
import FiltersCDynamicDefault from '@src/components/Filters/connectors/dynamicDefault';
import PopupCDefault from '../connectors/default';

const PopupCFilters = () => {
	const [isLoading, setIsLoading] = React.useState(true);

	const handleMount = React.useCallback(() => {
		setIsLoading(false);
	}, []);
	return (
		<PopupCDefault
			modalId={MODAL_IDS.TAG_FILTERS}
			adaptive="filter"
			isLoading={isLoading}
		>
			<FiltersCDynamicDefault onMount={handleMount} />
		</PopupCDefault>
	);
};

export default PopupCFilters;
